import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { FooterComponent } from './components/footer/footer.component';
import { LayoutComponent } from './components/layout/layout.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { provideShareButtonsOptions } from 'ngx-sharebuttons';
import { shareIcons } from 'ngx-sharebuttons/icons';
import { ShareButtons } from 'ngx-sharebuttons/buttons';
import { ShareReferralComponent } from '@app/pages/profile/viewer-profile/share-referral/share-referral.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/pages/shared/shared.module';
@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    LayoutComponent,
    ShareReferralComponent,
    LanguageSelectorComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ShareButtons,
    MatIconModule,
    MatIcon,
    MatMenuModule,
    MatSelectModule,
    MatOptionModule,
    SharedModule
  ],
  providers: [provideShareButtonsOptions(shareIcons())],
  exports: [
    NavbarComponent,
    FooterComponent,
    LayoutComponent,
    ShareReferralComponent,
    LanguageSelectorComponent,
  ],
})
export class LayoutModule { }

